import { Primary, PrimaryDark, LegacyOrange } from './Palettes';
export const palette = {
    primary: Primary,
    primaryDark: PrimaryDark,
    legacyOrange: LegacyOrange,
};
